export default "__VITE_ASSET__CHVE40rg__"